export default __webpack_public_path__ + "static/media/bs_img1.0c97b216.jpg";